// Small helper for AI/network calls that flake occasionally. Retries
// the operation once on failure before propagating the error.
//
// Usage:
//   const res = await callWithRetry(() => axios.post('/api/rephrase-text', body));
//
// Default options: 1 retry, 600ms delay between attempts.
export async function callWithRetry(fn, { retries = 1, delayMs = 600 } = {}) {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      // Don't retry on 4xx client errors (bad input, auth) — those won't
      // succeed on retry. Only retry network errors and 5xx server errors.
      const status = err?.response?.status;
      const isClientErr = typeof status === 'number' && status >= 400 && status < 500;
      if (isClientErr || attempt === retries) break;
      if (delayMs > 0) await new Promise(r => setTimeout(r, delayMs));
    }
  }
  throw lastErr;
}

export default callWithRetry;
